$(document).ready(function(){
	
  $('.testslider').bxSlider({
    controls: false,
    mode: 'fade'
  });
  
  $(".accpordion-head").click(function(){
    $(".accordion-row").not($(this).parent()).removeClass('accordion-active');
    $(this).parent().toggleClass('accordion-active');
    $('.accordion-body').not($(this).next(".accordion-body")).slideUp();
    $(this).next('.accordion-body').slideToggle();
  });
  
  $(".send-head").click(function(){
    $(".send-row").not($(this).parent()).removeClass('send-active');
    $(this).parent().toggleClass('send-active');
    $('.send-body').not($(this).next(".send-body")).slideUp();
    $(this).next('.send-body').slideToggle();
  });
  
  $('#nav').onePageNav({
    easing: 'easeInOutExpo',
    scrollSpeed: 1500
  });
  
  $(".responsive-nav").click(function(){
    $("ul#nav").slideToggle();
  });
  
  /*$("ul#nav a").click(function(){
    $("ul#nav").slideUp();
  });*/
  
  $(".privacy-content h3").click(function(){
    $(".privacy-row").not($(this).next(".privacy-row")).slideUp().removeClass("pr-row-active");
    $(this).next(".privacy-row").slideToggle().toggleClass("pr-row-active");
    $(".privacy-content h3").not($(this)).removeClass("pr-h3-active");
    $(this).toggleClass("pr-h3-active");
  });
  
  $(window).resize(function(){
    var winwidth = $(window).width();
    if(winwidth <= 767){
      $("ul#nav").removeClass("ul-block");
    }
    else{
      $("ul#nav").addClass("ul-block");
    }
  });


});